import React from 'react'
import './section-info-sale.scss';

import SliderGalery from '../../atoms/slider-galery/slider-galery';
import SliderBannerGalery from '../../../shared/components/atoms/slider-galery/slider-banner-galery';
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import numberCurrency from '../../../shared/utils/numberCurrency';
import iconLocation from '../../../shared/assets/images/icons/icon-location.svg';
import iconArea from '../../../shared/assets/images/icons/icon-area.svg';
import iconArrow from '../../../shared/assets/images/icons/icon-arrow-left.svg';
import ListRichText from '../../atoms/list-rich-text/list-rich-text';
import Redirect from '../../../shared/components/atoms/redirect/redirect';
import { utilGtm } from '../../../shared/utils/utilGtm';

const SectionInfoSale = props => {
    const { sale } = props;    
    const { 
        nombre, 
        valorInmueble, 
        direccionDelInmueble , 
        area, 
        metrosCuadradosConstruidos, 
        imgenesInmueble,
        tituloDistribucion,
        distribucion,
        enlaceTerminosYCondiciones,
        ciudad,
        videoDeYoutube,
        ubicacionInmueble,
        slug,
        banner
    } = sale;
    
    const backLink = () => ( 
        <Redirect url="bienes-en-venta" className="link back-button">
            <img src={ iconArrow } alt="icon back"></img>
            <span>Volver</span>
        </Redirect> 
    )
    
    return (
        <div className="o-section-info-sale">
            <div className="o-section-info-sale-breadcrumb">
                <Breadcrumb />
            </div>
            <div className="o-section-info-sale-back-desktop">
                { backLink() }
            </div>
            <div className="o-content-sales-row">
                <div className="o-content-sales-slider-container">                    
                    {                        
                        banner ? 
                            <SliderBannerGalery banner={banner} /> 
                        :  
                            <SliderGalery images={ imgenesInmueble } youtube={ videoDeYoutube } title={ nombre }/>
                    }
                    
                </div>
                <div className="o-content-sales-text-container">
                    <div className="o-content-sales-back-mobile">
                        { backLink() }
                    </div>
                    <h1 className="o-content-sales-text-title">{ nombre }</h1>
                    <p className="o-content-sales-text-title custom-h h2">{ numberCurrency( valorInmueble ) }</p>
                    <div className="o-content-sales-icon">
                        <img src={ iconLocation } alt="icon location"/>
                        <div className="o-content-sales-icon-text">
                            <p className="o-content-sales-text"> { direccionDelInmueble }</p>
                            {
                                ubicacionInmueble &&
                                <div>
                                    <br />
                                    <Redirect className="link" url={ `https://maps.google.com/?q=${ ubicacionInmueble.lat },${ ubicacionInmueble.lon }` }>Ver ubicación</Redirect>
                                </div>
                            }
                            {
                                ciudad && 
                                <>
                                    <br />
                                    <p className="o-content-sales-text"><b>Municipio:</b> {   ciudad.split('-')[1] }</p>
                                    <p className="o-content-sales-text"><b>Departamento:</b> { ciudad.split('-')[0] }</p>
                                </>
                            }
                        </div>
                    </div>
                    <div className="o-content-sales-icon">
                        {
                            (area || metrosCuadradosConstruidos) &&
                            <img src={ iconArea } alt="icon area"/>
                        }                        
                        <div className="o-content-sales-icon-text">
                            {
                                area &&
                                <p className="o-content-sales-text"><b>Área:</b> { area }m2</p>
                            }
                            {
                                metrosCuadradosConstruidos &&
                                <p className="o-content-sales-text"><b>Construcción:</b> { metrosCuadradosConstruidos }m2</p>
                            }
                        </div>
                    </div>
                    {
                        tituloDistribucion &&
                        <>
                            <h4 className="o-content-sales-subititle">{ tituloDistribucion }</h4>
                        </>
                    }
                    {
                        distribucion &&
                        <>
                            <ListRichText info={ distribucion.raw} />
                        </>
                    }
                    {
                        enlaceTerminosYCondiciones &&
                        <div className="o-content-sales-terminos">
                            <Redirect className="link" url={ enlaceTerminosYCondiciones }>
                                Términos y condiciones
                            </Redirect>
                        </div>
                    }                    
                    <Redirect gtm={ utilGtm( "gtmBienesClicContactarInterno", slug ) } url={'bienes-en-venta/' + slug + '/formulario/'} className="button">
                        CONTACTAR
                    </Redirect>
                </div>
            </div>
        </div>
    )
}

export default SectionInfoSale
